import React, { useRef, useState } from 'react'


import { useTranslation } from 'src/utils/i18n'
import GoogleMapReact from 'google-map-react'
import Card from '@mui/material/Card'
import { Icon } from '@iconify/react'
import dayjs from 'dayjs'

const POSITION = [
  {
    id: 1,
    time: 'Mon Dec 10 2018 08:45:00 GMT+0000 (GMT)',
    data: [
      {
        id: 1,
        position: '74 Ross Rd,Queanbeyan NSW, Australia',
        entry: 'Mon Dec 10 2018 08:45:00 GMT+0000 (GMT)',
        exit: 'Mon Dec 10 2018 09:00:00 GMT+0000 (GMT)',
        lat: -35.351597783737475,
        lng: 149.22415725799817
      }
    ]
  },
  {
    id: 2,
    time: 'Mon Dec 10 2018 08:45:00 GMT+0000 (GMT)',
    data: [
      {
        id: 2,
        position: '24 Surveyor St、Queanbeyan NSW, Australia',
        entry: 'Mon Dec 10 2018 09:20:00 GMT+0000 (GMT)',
        exit: 'Mon Dec 10 2018 09:26:00 GMT+0000 (GMT)',
        lat: -35.353026,
        lng: 149.224678
      },
      {
        id: 3,
        position: '31 Surveyor St、Queanbeyan NSW, Australia',
        entry: 'Mon Dec 10 2018 09:40:00 GMT+0000 (GMT)',
        exit: 'Mon Dec 10 2018 09:50:00 GMT+0000 (GMT)',
        lat: -35.352225,
        lng: 149.225235
      }
    ]
  }
]

function Geo() {
  const gpsData = []
  const [coordinate, setCoordinate] = useState(0)

  //google地图坐标
  const AnyReactComponent = ({ text, data }) => (
    <div onClick={() => setBgdata(data)} className='group'>
      {text}
      <div className='absolute w-[150px] h-[150px] bg-blue-300 bg-opacity-50 rounded-full -ml-12 -mt-9'></div>
      <div className='relative '>
        <div className='absolute flex items-center justify-center'>
          <div className='flex absolute w-[16px] h-[16px] rounded-full bg-[#0C0057] text-white items-center justify-center -mt-2'>
            {data.id}
          </div>
          <Icon icon='material-symbols:location-on-rounded' width={50} height={50} className='text-[#FF5252]'></Icon>
        </div>
      </div>
    </div>
  )

  //google地图坐标
  const AnyReactComponents = ({ text }) => (
    <div className='' onClick={() => setCheck(mapdata.id)}>
      {text}
      <div className='relative flex '>
        <div
          className=' absolute w-[380px] h-[100px] -mt-24 -ml-[160px] text-[13px]  text-[#4d5976] text-opacity-90 font-[500] bg-white  rounded-xl'
          style={{ visibility: mapdata.position === '' ? 'hidden' : 'visible' }}
        >
          <div className='text-[15px] text-[#334062] p-4  font-[600]'>{mapdata.position}</div>
          <div className='flex justify-between px-4'>
            <div className='flex items-center'>
              <div className='w-[25px] h-[20px]'>
                <span>
                  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='18' fill='none' viewBox='0 0 13 18'>
                    <path
                      fill='#667089'
                      d='M7.3 14.316l4.46-4.461 1.177 1.176-6.469 6.468L0 11.031l1.176-1.176 4.46 4.46V4.194H7.3v10.123z'
                    ></path>
                    <path fill='#667089' d='M5.636 0H7.299V2.8H5.636z'></path>
                  </svg>
                </span>
              </div>
              <div className=''>
                <p className='font-[500]'>Entry on</p>
                <div className='text-[14px] mt-1 font-[500]'>{dayjs(mapdata.entry).format('D MMM,hh:mm a')}</div>
              </div>
            </div>
            <p className='text-[25px] text-[#334062] text-opacity-50'>|</p>
            <div className='flex items-center'>
              <div className='w-[25px] h-[20px]'>
                <span>
                  <svg xmlns='http://www.w3.org/2000/svg' width='13' height='18' fill='none' viewBox='0 0 13 18'>
                    <path
                      fill='#667089'
                      d='M5.7 3.184L1.24 7.645.062 6.469 6.532.001 13 6.469l-1.176 1.176-4.46-4.46v10.122H5.7V3.184z'
                    ></path>
                    <path fill='#667089' d='M7.364 17.5H9.027V20.3H7.364z' transform='rotate(-180 7.364 17.5)'></path>
                  </svg>
                </span>
              </div>
              <div className=''>
                <p className='font-[500]'>Exit at</p>
                <div className='text-[14px] mt-1 font-[500]'>{dayjs(mapdata.exit).format('D MMM,hh:mm a')}</div>
              </div>
            </div>
          </div>
        </div>
        <div className='absolute flex items-center justify-center'>
          <div className='flex absolute w-[16px] h-[16px] rounded-full bg-[#0C0057] text-white items-center justify-center -mt-2'>
            {mapdata.id}
          </div>
          <Icon icon='material-symbols:location-on-rounded' width={50} height={50} className='text-[#FF5252]'></Icon>
        </div>
      </div>
    </div>
  )

  const [bgdata, setBgdata] = useState(-1)

  const [check, setCheck] = useState(0)

  const [err, setErr] = useState(false)

  const [mapdata, setMapdata] = useState({
    id: 1,
    position: '',
    lat: '',
    lng: ''
  })

  const [positiondata, setPositiondata] = useState(POSITION)

  const inputChangeHandler = e => {
    const valueData = e.target.value.trim().toLowerCase()

    const Data = POSITION.filter(i => i.data.filter(item => item.position.toLowerCase().indexOf(valueData) !== -1))

    //setPositiondata(Data)
  }

  const defaultProps = {
    center: {
      lat: -35.351597783737475,
      lng: 149.22415725799817
    },
    zoom: 17
  }

  //const DataTime = dayjs().format('D MMM,hh:mm a')
  //const DataTime2 = dayjs().format()

  const Geofencing = index => {
    return positiondata[index].data.map(item => {
      gpsData.push(item)
      const entry = dayjs(item.entry).format('D MMM,hh:mm a')
      const exit = dayjs(item.exit).format('D MMM,hh:mm a')

      return (
        <div key={item.id} onClick={() => setMapdata(item)}>
          <div
            className='w-[98%]  flex h-5/6 items-center mx-auto p-2 cursor-pointer hover:bg-[#edeff5] hover:rounded-xl mt-2 rounded-xl'
            onClick={() => setBgdata(item)}
            style={{ backgroundColor: item.id === bgdata.id ? '#edeff5' : '' }}
          >
            <div className='flex w-[30px] h-[30px] bg-[#d0d2d8] rounded-full'>
              <p className='text-[0.9rem] flex items-center mx-auto text-[#4d5976] font-bold '>{item.id}</p>
            </div>
            <div className='ml-2 w-10/12 h-full p-1'>
              <h2 className='text-[#4d5976] text-[0.82rem]   font-semibold'>{item.position}</h2>

              <div className='flex mt-2'>
                <div className='flex w-1/2 h-full border-r-[1px] border-black border-opacity-20 items-center'>
                  <span>
                    <svg xmlns='http://www.w3.org/2000/svg' width='13' height='18' fill='none' viewBox='0 0 13 18'>
                      <path
                        fill='#667089'
                        d='M7.3 14.316l4.46-4.461 1.177 1.176-6.469 6.468L0 11.031l1.176-1.176 4.46 4.46V4.194H7.3v10.123z'
                      ></path>
                      <path fill='#667089' d='M5.636 0H7.299V2.8H5.636z'></path>
                    </svg>
                  </span>
                  <p className='text-[#667089] text-[0.7rem] ml-2 font-[420]'>{entry}</p>
                </div>
                <div className='flex w-1/2 h-full items-center ml-2 '>
                  <span>
                    <svg xmlns='http://www.w3.org/2000/svg' width='13' height='18' fill='none' viewBox='0 0 13 18'>
                      <path
                        fill='#667089'
                        d='M5.7 3.184L1.24 7.645.062 6.469 6.532.001 13 6.469l-1.176 1.176-4.46-4.46v10.122H5.7V3.184z'
                      ></path>
                      <path fill='#667089' d='M7.364 17.5H9.027V20.3H7.364z' transform='rotate(-180 7.364 17.5)'></path>
                    </svg>
                  </span>
                  <p className='text-[#667089] text-[0.7rem] ml-2 font-[420] '>{exit}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    })
  }

  const TodayHandler = () => {
    setCheck(1)

    const Data = POSITION.map(item => {
      const time = dayjs(item.time).format('YYYY-MM-DD')
      const Today = dayjs().format('YYYY-MM-DD')
      if (time !== Today) {
        setErr(true)
        setPositiondata([])
      }
    })
  }

  const yesterdayHandler = () => {
    setCheck(2)

    const Data = POSITION.map(item => {
      const time = dayjs(item.time).format('YYYY-MM-DD')
      const yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
      if (time === yesterday) {
        setPositiondata(item.data)
      } else {
        setErr(true)
        setPositiondata([])
      }
    })
  }

  const lastweekHandler = () => {
    setCheck(3)

    const Data = POSITION.map(item => {
      const time = dayjs(item.time).format('YYYY-MM-DD')
      const lastWeek = dayjs().subtract(7, 'day').format('YYYY-MM-DD')
      if (time === lastWeek) {
        setPositiondata(item.data)
      } else {
        setErr(true)
        setPositiondata([])
      }
    })
  }

  const allHandler = () => {
    setCheck(4)
    setErr(false)
    setPositiondata(POSITION)
  }

  return (
    <Card>
      <div className='lg:flex '>
        <div className='w-[38%] Mlg:w-full h-full overflow-auto items-center bg-[#fcfdfe] border-[#e6e7ec] border-r-[1px]'>
          <div className=''>
            <div className='flex static h-[60px] items-center w-[92%] mx-auto'>
              <i className='absolute z-10 '>
                <Icon icon='ep:search' className='w-[18px] h-[18px] text-black text-opacity-60 ml-1' />
              </i>
              <input
                onChange={inputChangeHandler}
                className='inline-block w-full h-[46px]  rounded-xl outline-none pl-8 text-[15px] relative border-[1px] border-[#e4e7ee] font-[420]'
                type='text'
                placeholder='Search Geofence'
              />
            </div>
          </div>

          <div className='group  grid grid-cols-4 gap-x-2 h-[28px] w-11/12 mx-auto'>
            <div
              onClick={TodayHandler}
              style={{ backgroundColor: check === 1 ? '#F0F0F0' : '' }}
              className='flex items-center justify-center font-[600] text-[12px] text-black text-opacity-60 h-full rounded-lg cursor-pointer truncate'
            >
              Today
            </div>
            <div
              onClick={yesterdayHandler}
              style={{ backgroundColor: check === 2 ? '#F0F0F0' : '' }}
              className='flex items-center justify-center font-[600] text-[12px] text-black text-opacity-60 h-full rounded-lg cursor-pointer truncate'
            >
              Yesterday
            </div>
            <div
              onClick={lastweekHandler}
              style={{ backgroundColor: check === 3 ? '#F0F0F0' : '' }}
              className='flex items-center justify-center font-[600] text-[12px] text-black text-opacity-60 h-full rounded-lg cursor-pointer truncate'
            >
              Last 7 days
            </div>
            <div
              onClick={allHandler}
              style={{ backgroundColor: check === 4 ? '#F0F0F0' : '' }}
              className='flex items-center justify-center font-[600] text-[12px] text-black text-opacity-60 h-full rounded-lg cursor-pointer truncate '
            >
              All
            </div>
          </div>

          {err && (
            <div className='flex mt-2 w-1/2 mx-auto text-center'>
              <p className='text-[14px] font-[500] flex mx-auto text-red-600'>
                The location corresponding to the current time is not found!
              </p>
            </div>
          )}

          <div className='w-full p-2'>
            {positiondata.map((item, index) => {
              const time = dayjs(item.time).format('ddd,DD MMM,YYYY')

              return (
                <div key={item.id} className='mt-2'>
                  <div className='flex justify-center'>
                    <h2 className='flex items-center justify-center text-[13px] text-[#4d5976] w-[70%] h-[40px] rounded-full shadow-2xl font-[500]'>
                      {time}
                    </h2>
                  </div>
                  <div className='pt-2'>{Geofencing(index)}</div>
                </div>
              )
            })}
          </div>
        </div>

        <div style={{ height: 'var(--vh)*100', width: '100%' }} className='Mlg:border-t-[1px]'>
          <div className='h-[60px] items-center flex justify-between w-[95%] mx-auto'>
            <div className='flex  items-center w-[70%]'>
              <div className='w-[40px] h-[40px] bg-[#edeff3] items-center flex rounded-full sm:w-[40px] sm:h-[30px]'>
                <Icon icon='ic:baseline-location-on' width={20} height={20} className='mx-auto ' />
              </div>
              <div className='ml-4'>
                <p className='text-[#334062] font-bold text-opacity-80 Mlg:text-[14px] sm:text-[12px]'>
                  {mapdata.position}
                </p>
              </div>
            </div>
            <div className='flex items-center'>
              <div className='pr-2'>
                <Icon icon='bx:location-plus' className='text-[#3a8dfe] w-[20px] h-[20px]' />
              </div>
              <div>
                <span className='text-[0.8125rem] text-[#4d5976] font-[500] sm:text-[12px]'>Add New Geofence</span>
              </div>
            </div>
          </div>

          <div className='w-full h-[94.3%] p-[1px]'>
            <GoogleMapReact
              bootstrapURLKeys={{ key: `${process.env.NEXT_PUBLIC_GOOGLE_KEY}` }}
              defaultCenter={defaultProps.center}
              defaultZoom={defaultProps.zoom}
            >
              {positiondata.map(item => {
                return item.data.map(index => {
                  return <AnyReactComponent key={item.id} lat={index.lat} lng={index.lng} text='' data={index} />
                })
              })}

              <AnyReactComponents lat={mapdata.lat} lng={mapdata.lng} text='' />
            </GoogleMapReact>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default Geo


